(function () {
  const initSlider = (section) => {
    const swiperEl = section.querySelector(".js-image-text-slider");
    if (!swiperEl) return;

    const nextBtn = section.querySelector(".image-text-slider__nav-next");
    const prevBtn = section.querySelector(".image-text-slider__nav-prev");

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 16,
      speed: 600,
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: {
        750: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
      },
    });
  };

  const initSection = (section) => {
    if (!section || !section.classList.contains("image-text-slider-section")) {
      return;
    }
    initSlider(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
